"use client"

import Image from "next/image"
import Link from "next/link"
import { useMemo, useSyncExternalStore } from "react"
import { usePathname } from "next/navigation"

const SCROLL_Y = 24

function subscribeScroll(cb: () => void) {
    window.addEventListener("scroll", cb, { passive: true })
    return () => window.removeEventListener("scroll", cb)
}

function getScrollSnapshot() {
    return window.scrollY || 0
}

function getServerSnapshot() {
    return 0
}

export function Header() {
    const pathname = usePathname()
    const isHome = pathname === "/"

    const scrollY = useSyncExternalStore(
        subscribeScroll,
        getScrollSnapshot,
        getServerSnapshot
    )

    const scrolled = !isHome ? true : scrollY > SCROLL_Y

    const chrome = useMemo(() => {
        // Transparent over hero. Dark surface after scroll or on inner pages.
        if (isHome && !scrolled) {
            return {
                header: "bg-transparent",
                inner: "py-6",
                logoSrc: "/logo/BAM__Full_White_RGB.svg",
            } as const
        }

        return {
            header:
                "bg-[rgba(0,13,20,0.92)] backdrop-blur shadow-[var(--shadow-md)]",
            inner: "py-4",
            logoSrc: "/logo/BAM__Full_White_RGB.svg",
        } as const
    }, [isHome, scrolled])

    return (
        <header className={`fixed inset-x-0 top-0 z-50 ${chrome.header}`} aria-label="Site header">
            <div className={`bam-container flex items-center px-6 ${chrome.inner}`}>
                <Link href="/" className="inline-flex items-center" aria-label="Barnickel Asset Management">
                    <Image
                        src={chrome.logoSrc}
                        alt="Barnickel Asset Management"
                        width={220}
                        height={44}
                        priority
                        className="h-9 w-auto"
                    />
                </Link>
            </div>
        </header>
    )
}